import { Map } from 'immutable';

import { OPERATIONS } from '../../../../constants/bulkEdit';
import { ATTRIBUTE } from '../../../../constants/attributes';

import actions from '../../../../actions';

export function productType({ channel, preview, shopId }) {
  const value = preview.get(ATTRIBUTE.PRODUCT_TYPE);
  const index = preview.get('index');
  const payload = Map({ type: OPERATIONS[channel].PRODUCT_TYPE, value: value || '' });
  const actionsToDispatch = [];

  if (value && index === -1) {
    actionsToDispatch.push(actions.data.addProductType({ shopId, productType: value }));
  }

  return { actions: actionsToDispatch, payload };
}
